import React, { useEffect, useState, useCallback } from 'react';
import { Link, NavLink } from 'react-router-dom';
import GlyphSvg from '../components/Glyphs';
import '../utils/navigation.css';
import Navbar from './Navbar';

const iconIds = [
  'g01', 'g02', 'g03', 'g04', 'g05',
  'g06', 'g07', 'g08', 'g09', 'g10', 'g11'
];

export default function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentGlyph, setCurrentGlyph] = useState(iconIds[0]);
  const [isInverted, setIsInverted] = useState(false); // NEW STATE FOR INVERSION

  // ANIMATE GLYPHS
  const animateGlyph = useCallback((itemId, from, to) => {
    let current = from;
    const step = from < to ? 1 : -1;

    const interval = setInterval(() => {
      const glyph = `g${current.toString().padStart(2, '0')}`;
      setCurrentGlyph(glyph);

      if (current === to) {
        clearInterval(interval);
      } else {
        current += step;
      }
    }, 25);
  }, []);

  // Effect to manage nav-invert class based on scroll/overlap
  useEffect(() => {
    const nav = document.getElementById('main-nav');
    if (!nav) return;

    const handleScroll = () => {
      const navHeight = nav.offsetHeight;
      const sections = document.querySelectorAll('.dark-section');
      let overlap = false;

      for (let section of sections) {
        const rect = section.getBoundingClientRect();
        if (rect.top < navHeight && rect.bottom > 0) {
          overlap = true;
          break;
        }
      }
      // Update React state instead of directly manipulating DOM classList
      setIsInverted(overlap);
    };

    // Initial check and event listeners
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []); // Empty dependency array means this runs once on mount and sets up listeners

  // Effect to manage body overflow and glyph animation
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';

    if (menuOpen) {
      animateGlyph('menuButton', 1, 5);
    } else {
      animateGlyph('menuButton', 5, 1);
    }
  }, [menuOpen, animateGlyph]);

  // Determine glyph color based on inversion and menu state
  // You'll need to define what 'inverted' means for the glyph color in your CSS
  const glyphColor = isInverted && !menuOpen ? 'white' : 'black'; // Example logic: white when inverted and menu is closed, otherwise black

  return (
    <>
      <style>
        {`
          .fullscreen-nav .nav-link {
            font-family: var(--font-a);
            text-transform: uppercase;
          }
        `}
      </style>
      <nav
        id="main-nav"
        // Conditionally apply nav-invert based on React state
        className={`px-lg-5 navbar navbar-expand-lg ${menuOpen ? 'menu-open' : ''} ${isInverted ? 'nav-invert' : ''}`}
        style={{ 
          pointerEvents: 'auto' // Changed from 'none' to 'auto' to allow clicks
        }}
      >
      <div className="container-fluid d-flex align-items-center justify-content-between" style={{ pointerEvents: 'auto' }}>
        {/* Mobile Hamburger */}
        <button
          className="navbar-toggler order-1 d-lg-none"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className="nav-icon">
            {/* Pass glyphColor dynamically */}
            <GlyphSvg glyph={currentGlyph} size={('12')} color={glyphColor} />
          </div>
        </button>

        {/* Logo */}
        <Link
                      className="navbar-logo order-2 order-lg-1 f-a fs-3"
          to="/"
        >
          ITORA
        </Link>

        {/* Mobile CTA Button */}
        <Link
          to="/contact"
          className="btn order-3 d-lg-none nav-cta"
          style={{ fontSize: '0.6rem' }}
          onClick={() => setMenuOpen(false)}
        >
          BOOK DEMO
        </Link>

        {/* Desktop Nav */}
        <div className="collapse navbar-collapse justify-content-between order-lg-2 d-none d-lg-flex">
          <div className="mb-2 mb-lg-0">
            <Navbar setMenuOpen={setMenuOpen} />
          </div>
          <Link to="/contact" className="btn nav-cta" style={{ fontSize: '0.6rem' }}>
            BOOK DEMO
          </Link>
        </div>
      </div>

      {/* Mobile Fullscreen Slide-In Nav */}
      <div className="fullscreen-nav d-lg-none" style={{ pointerEvents: 'auto' }}>
        <div className="text-center">
          <Navbar setMenuOpen={setMenuOpen} />
        </div>
      </div>
      </nav>
    </>
  );
}